export enum CustomPositionFields {
    Description,
    Price,
    OrderUnit,
    IsNormArticle,
    ArticleNumber,
    Tax,
    Quantity,
    ContentQuantity,
    ContentUnit,
}
